export const PERIODICITY_RADIO_BUTTONS = [
  {
    id: 'open',
    name: 'periodicity',
    label: 'Open',
    value: 'Open',
  },
  {
    id: 'closed',
    name: 'periodicity',
    label: 'Closed',
    value: 'Closed',
  },
  {
    id: 'all',
    name: 'periodicity',
    label: 'All',
    value: 'All',
  },
]
